module.exports = __webpack_public_path__ + "static/rails2-8964b3dcf666be30326247564fe260dd.png";